import { FC, useEffect, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { ApolloError, useMutation } from '@apollo/client';
import { Redirect } from 'react-router-dom';

import { pageAlertConfigState } from 'components/common/PageAlert/PageAlert.state';
import { PageAlertVariant } from 'components/common/PageAlert/PageAlert.types';
import * as K from 'common/constants';
import LoadingPlaceholder from 'components/common/LoadingPlaceholder/LoadingPlaceholder';
import { searchParamState } from 'components/common/Managers/RouteStateManager.state';

import { SIGN_IN_TO_SLACK } from './queries';

const URL_REGEXP = /^.*\/\/[^/]+/;

/**
 * Removes protocol and domain name from the URL.
 * Example:
 * Input: "https://www.scalyr.com/slackoauth?code=123243"
 * Output: "/slackoauth?code=123243"
 *
 * @param   url absolute URL
 *
 * @returns relative url
 */
const stripProtocolAndDomainName = (url: string): string => url.replace(URL_REGEXP, '');

const SlackOAuthPage: FC = () => {
  const [slackResponse, setSlackResponse] = useState(false);
  const code = useRecoilValue(searchParamState(K.URL_PARAM.CODE));
  const state = useRecoilValue(searchParamState(K.URL_PARAM.STATE));
  const setPageAlertConfig = useSetRecoilState(pageAlertConfigState);
  const showErrorAlert = (message: string): void => {
    setPageAlertConfig({ message, variant: PageAlertVariant.ERROR, autoHide: true });
  };
  const [signInToSlack] = useMutation(SIGN_IN_TO_SLACK, {
    onCompleted: () => {
      setSlackResponse(true);
    },
    onError: (error: ApolloError) => {
      setSlackResponse(true);
      showErrorAlert(error.message);
    },
  });

  useEffect(() => {
    if (code) {
      signInToSlack({ variables: { code } });
    }
  }, [code, signInToSlack]);

  if (slackResponse) {
    return <Redirect to={stripProtocolAndDomainName(state)} />;
  }
  return <LoadingPlaceholder />;
};

export default SlackOAuthPage;
